import { CARGO_TYPE, TItemType } from '@types';

/** What an Item type's ranges count: "Bundles", "Skids", "Units" or "Pallets". */
export const formatItemTypeUnits = (itemType: Pick<TItemType, 'cargo_type'>) => {
	switch (itemType.cargo_type) {
	case CARGO_TYPE.SKID:
		return 'Skids';
	case CARGO_TYPE.OTHER:
		return 'Units';
	case CARGO_TYPE.PALLETS:
		return 'Pallets';
	default:
		return 'Bundles';
	}
}
